export default "__VITE_ASSET__c112170c__"